// Shared open/close helpers keep class state, the overlay, and aria-expanded in sync
// for the desktop dropdowns. The trigger link is `.parent-sub > span a`.
const NAV_FOCUSABLE = 'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])';

function visibleFocusable(container) {
    return Array.from(container.querySelectorAll(NAV_FOCUSABLE))
        // offsetParent is null for display:none elements (e.g. the desktop-hidden .sub-menu-back)
        .filter(el => el.offsetParent !== null);
}

function openDrop($li) {
    $('.parent-sub').not($li).each(function () { closeDrop($(this)); });
    $li.addClass('menu-active');
    $li.find('.sub-menu').addClass('show-sub-menu');
    $li.find('.sub-sub-menu').removeClass('sub-active');
    $li.find('> span a').attr('aria-expanded', 'true');
    $('#nav-overlay').addClass('is-active');
}

function closeDrop($li) {
    $li.removeClass('menu-active');
    $li.find('.sub-menu').removeClass('show-sub-menu');
    $li.find('> span a').attr('aria-expanded', 'false');
    if (!$('.parent-sub.menu-active').length) {
        $('#nav-overlay').removeClass('is-active');
    }
}

// Trap Tab/Shift+Tab within an open dropdown, but only while focus is already inside it
// so hover-opening a menu never hijacks keyboard focus.
document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    const openLi = document.querySelector('.parent-sub.menu-active');
    if (!openLi || !openLi.contains(document.activeElement)) return;
    const items = visibleFocusable(openLi);
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) {
        last.focus();
        e.preventDefault();
    } else if (!e.shiftKey && document.activeElement === last) {
        first.focus();
        e.preventDefault();
    }
});

if ($( window ).width() >= 1300)
{
    $('body').append('<div id="nav-overlay"></div>');

    let closeTimer;

    $('.parent-sub').on('mouseenter', function() {
        clearTimeout(closeTimer);
        openDrop($(this));
    }).on('mouseleave', function() {
        const $this = $(this);
        closeTimer = setTimeout(function() {
            closeDrop($this);
        }, 150);
    }).on('click', function() {
        if ($(this).hasClass('menu-active')) {
            closeDrop($(this));
        } else {
            openDrop($(this));
        }
    });

    $( ".sub-sub-menu").click(function(e){
        e.stopPropagation();
        $(this).toggleClass('sub-active');
    });
    //
    //
    // $(".sub-sub-menu").on('mouseenter mouseleave', function (e) {
    //     if ($(this).length) {
    //         let val = 0;
    //         let widthOfList = $(this).find('.js-show > ul').outerWidth();
    //         let widthOfSecondList = $(this).outerWidth();
    //         var elm = $(this).find('ul:first');
    //         var off = elm.offset();
    //         var l = off.left;
    //         var w = elm.width();
    //         var docH = $("body").height();
    //         var docW = $("body").width();
    //         var isEntirelyVisible = (l + w <= docW);
    //         if (!isEntirelyVisible) {
    //             let val = Number(widthOfList) + Number(widthOfSecondList);
    //             $(this).find('ul:first').css("transform", `translateX(-${val}px)`);
    //             // console.log('edge');
    //         } else {
    //             $(this).removeClass('edge');
    //             // console.log('non-edge');
    //         }
    //     }
    // });

}else{
    // Mobile
    $( ".parent-sub").click(function(e) {
        if ($(e.target).closest('.sub-menu').length) return; // sub-menu links navigate normally
        e.preventDefault(); // parent tap opens the sub-menu instead of following its href
        if($(this).hasClass('menu-active')){
            $('.parent-sub').removeClass('menu-active');
            $(this).find('.sub-menu').removeClass('show-sub-menu');
            return;
        }else{
            $('.parent-sub').removeClass('menu-active')
            $('.show-sub-menu').removeClass('show-sub-menu');
            $(this).addClass('menu-active')
        }
        $(this).find('.sub-menu').toggleClass('show-sub-menu');
        $(this).find('.sub-sub-menu').removeClass('sub-active');
    });

    $('.sub-menu-back').on('click', function(e) {
        e.stopPropagation();
        var $parentSub = $(this).closest('.parent-sub');
        $parentSub.removeClass('menu-active');
        $parentSub.find('.sub-menu').removeClass('show-sub-menu');
    });

    $( ".sub-sub-menu").click(function(e){
        e.stopPropagation();
        $(this).toggleClass('sub-active');
    });
    // $('#navbarToggle').on('click', function() {
    //     var primaryNavigation = $('.site-navigation');
    //     // Dropdown toggle setup
    //     if(primaryNavigation.hasClass('mobile-show')) {
    //         primaryNavigation.removeClass('mobile-show');
    //         $('body').removeClass('no-scroll');
    //         $('#navbarToggle').addClass('collapsed');
    //         $('#navbarToggle').attr('aria-expanded', 'false');
    //
    //     } else {
    //         primaryNavigation.addClass('mobile-show');
    //         $('body').addClass('no-scroll');
    //         $('#navbarToggle').removeClass('collapsed');
    //         $('#navbarToggle').attr('aria-expanded', 'true');
    //     }
    // });
}

$('a[href="#"]').on('click', function(e) {
    e.preventDefault();
    // A menu-title with no real URL is just a column heading — stop the click
    // from bubbling to the .parent-sub / body handlers so the dropdown stays open.
    if ($(this).hasClass('menu-title')) {
        e.stopPropagation();
    }
});

//removes dropdown menu active class when clicking outside of element
$('body').on('click', function(e) {
    var dropdownMenu = $('.show-sub-menu,.parent-sub');
    if(dropdownMenu !== event.target && !dropdownMenu.has(event.target).length){
        $('.parent-sub').removeClass('menu-active');
        $('.sub-menu').removeClass('show-sub-menu');
        $('.parent-sub > span a').attr('aria-expanded', 'false');
        $('.sub-sub-menu').removeClass('sub-active');
        $('.js-show').removeClass('show-sub-sub');
        $('#nav-overlay').removeClass('is-active');

    }
});





(function($) {
    // Toggle collapse on submenu
    $('#navbarToggle').on('click', function() {
        var primaryNavigation = $('.site-navigation');
        $this = $(this);

        // Dropdown toggle setup
        if(primaryNavigation.hasClass('mobile-show')) {
            primaryNavigation.removeClass('mobile-show');
            $('body').removeClass('no-scroll');
            document.body.style.paddingRight = '';
            $this.addClass('collapsed');
            $this.attr('aria-expanded', 'false');

        } else {
            const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
            document.body.style.paddingRight = scrollbarWidth + 'px';
            primaryNavigation.addClass('mobile-show');
            $('body').addClass('no-scroll');
            $this.removeClass('collapsed');
            $this.attr('aria-expanded', 'true');
        }
    });

    $('.mobile-nav-close').on('click', function() {
        var primaryNavigation = $('.site-navigation');
        primaryNavigation.removeClass('mobile-show');
        $('body').removeClass('no-scroll');
        document.body.style.paddingRight = '';
        $('#navbarToggle').addClass('collapsed').attr('aria-expanded', 'false');
    });
}(jQuery));

$(document).on('keyup', function(e) {
    if (e.key !== 'Escape' && e.keyCode !== 27) return;
    const $open = $('.parent-sub.menu-active');
    if (!$open.length) return;
    const trigger = $open.find('> span a')[0];
    closeDrop($open);
    if (trigger) trigger.focus(); // return focus to the trigger that opened the menu
});